/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Owner_Cannot_LeaveInputs */

const en_us2_group_owner_cannot_leave = /** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The group's creator cannot leave it.`)
};

const pt_br2_group_owner_cannot_leave = /** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem criou a turma não pode sair dela.`)
};

const pt_pt2_group_owner_cannot_leave = /** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem criou a turma não pode sair dela.`)
};

/** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */
const es_419_group_owner_cannot_leave = en_us2_group_owner_cannot_leave;

/** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */
const fr_fr2_group_owner_cannot_leave = en_us2_group_owner_cannot_leave;

/** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */
const de_de2_group_owner_cannot_leave = en_us2_group_owner_cannot_leave;

/** @type {(inputs: Group_Owner_Cannot_LeaveInputs) => LocalizedString} */
const it_it2_group_owner_cannot_leave = en_us2_group_owner_cannot_leave;

/**
* | output |
* | --- |
* | "The group's creator cannot leave it." |
*
* @param {Group_Owner_Cannot_LeaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_owner_cannot_leave = /** @type {((inputs?: Group_Owner_Cannot_LeaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Owner_Cannot_LeaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_owner_cannot_leave(inputs)
	if (locale === "es-419") return es_419_group_owner_cannot_leave(inputs)
	if (locale === "pt-PT") return pt_pt2_group_owner_cannot_leave(inputs)
	if (locale === "fr-FR") return fr_fr2_group_owner_cannot_leave(inputs)
	if (locale === "de-DE") return de_de2_group_owner_cannot_leave(inputs)
	if (locale === "it-IT") return it_it2_group_owner_cannot_leave(inputs)
	return en_us2_group_owner_cannot_leave(inputs)
});
export { group_owner_cannot_leave as "group.owner_cannot_leave" }